export enum ClubhouseActionType {
    SendMessage = 0,
    LikeMessage = 1,
    ReviewDraft = 2,
}

export interface ClubhouseActionFailed {
    action: ClubhouseActionType;
    clubhouseId: number;
    discussionId: number;
    messageId?: number;
    reason: string;
}
